export function getDynamicDataTable(linkColumns:any,modalKey:string,linkField:string, label:string ){

    return {
  "type": "fgDynamicDataTable",
  "name": "Dynamic Data Table",
  "icon": "fa fa-th-list",
  "values": [],
  "validation": {},
  "condition": {},
  "isCoreConfig": true,
  "category": "LAYOUT",
  "uuid": crypto.randomUUID(),
  "children": [ linkColumns
  ],
  "datatableConfig": {
    "itemPerPage": 10,
    "iconButtonsEnabled": true,
    "isAddActionEnabled": true,
    "isRemoveActionEnabled": true,
    "addModalKey": modalKey,
    "isInlineRemoveActionEnabled": true,
    "chooseIcon": true
  },
  "dataTableConfig": {},
  "moveConfirmationConfig": {},
  "key": linkField,
  "label": label,
  "formBasedDataGrid": true
}

}

export function getDynamicDataTableTrial(modalId:any , formFields?:any, label?:any){

    return {
  "type": "fgDynamicDataTable",
  "name": "Dynamic Data Table",
  "icon": "fa fa-th-list",
  "values": [
    
  ],
  "validation": {
    "required": false,
    "minLength": null,
    "maxLength": null
  },
  "condition": {
    
  },
  "isCoreConfig": true,
  "category": "INPUT",
  "uuid": crypto.randomUUID(),
  "children": [
    
  ],
  "datatableConfig": {
    "itemPerPage": 10,
    "iconButtonsEnabled": true,
    "isAddActionEnabled": true,
    "isRemoveActionEnabled": false,
    "addModalKey": modalId,
    "isInlineRemoveActionEnabled": true,
    "chooseIcon": true,
    "selectedField": {
      "tag": "General",
      "name": "DEADLINE",
      "type": "date",
      "displayName": "Deadline",
      "description": null,
      "defaultValue": null,
      "systemDefined": null,
      "isEditable": null,
      "isSearchable": null,
      "isGroupable": null,
      "isSortable": null,
      "isAuditable": null,
      "isWorkflowEnabled": null,
      "minLength": 0,
      "maxLength": 13,
      "isUnique": null,
      "isMandatory": false,
      "isPrimaryKey": false,
      "isLink": null,
      "pattern": null,
      "prefix": null,
      "suffix": null,
      "isMesurable": null,
      "isDimensional": null,
      "isParty": null,
      "lookUpReference": null,
      "fieldType": null,
      "filterLookUpReference": null,
      "fieldTypeKey": null,
      "isAuthflowEnabled": null,
      "isSecured": null,
      "translationFieldCode": null,
      "isNonPersistField": null,
      "isConfirmationField": null,
      "isAcknowledgementField": null,
      "identifierKey": null,
      "authflowResolver": null,
      "weight": 0,
      "isIndexing": null,
      "modelCode": modalId,
      "isFreeText": null,
      "isFacet": null,
      "securityType": null,
      "encryptionType": null,
      "algorithm": null,
      "persistWithMasking": null,
      "maskChar": null,
      "maskStart": null,
      "maskEnd": null,
      "isEncryptionEnabled": null,
      "translationValueField": null,
      "translationDisplayField": null,
      "isDynamicField": null,
      "dynamicFieldExpression": null,
      "isObjectSecurity": null,
      "expressionLanguage": null,
      "dateFormatToken": null,
      "referenceGenCode": null,
      "maxDigit": null,
      "seedValue": null,
      "deferIdGenerate": null,
      "defaultAsUuid": null,
      "isMultiSelect": null,
      "virtualFieldExpression": null,
      "virtualFieldPattern": null
    },
    "columns": formFields
  },
  "dataTableConfig": {
    "dataSourceType": "model",
    "selectedModel": modalId
  },
  "moveConfirmationConfig": {
    
  },
  "key": modalId,
  "label": label,
  "formBasedDataGrid": false,
  "prefix": null,
  "tag": "Link",
  "formBasedDataDynamicColumn": false,
  "isRelationship": false,
  "linkModel": ""
}

}